var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotification = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 25,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.64 8.623c0-1.92.715-3.76 1.988-5.117 1.272-1.358 2.998-2.12 4.797-2.12 1.8 0 3.526.762 4.799 2.12 1.272 1.357 1.987 3.198 1.987 5.117 0 8.444 3.393 10.857 3.393 10.857H1.247S4.64 17.067 4.64 8.623M9.47 22.873a2.26 2.26 0 0 0 3.913 0"
})));
export default SvgNotification;